/** Functional-domain scopes a personal API key can be granted. Mirrors the API's PublicApiScope. */
export const PUBLIC_API_SCOPES: ReadonlyArray<{ value: string; label: string }> = [
	{ value: 'levitate:contacts', label: 'Contacts' },
	{ value: 'levitate:campaigns', label: 'Campaigns' },
];
